import { useTranslation, Trans } from "react-i18next";

import { LinkContext } from "../../LinkProvider";
import { useContext } from "react";

import n_d from '../../img/SpecialOffers/number_d.png'
import n_m from '../../img/SpecialOffers/number_m.png'

import s1 from '../../img/SpecialOffers/s1.png';
import s2 from '../../img/SpecialOffers/s2.png';
import smob from '../../img/SpecialOffers/smob.png'

import Button from "../Button";

import { Fade } from 'react-awesome-reveal'

function Campaign() {

  const { t } = useTranslation();

  const { link } = useContext(LinkContext);

  return (
    <div className="relative overflow-hidden">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto h-[608px] xl:h-[484px] bg-white">
        <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#1E1C21] text-center pt-[80px]">
            <Trans>{t("offers.27")}</Trans>
        </p>
        <div className="flex flex-col items-start xl:items-center">
            <div className="xl:flex items-center justify-center gap-[65px] mt-[60px] hidden">
                <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] w-[205px] text-center">{t('offers.28')}</p>
                <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] w-[205px] text-center">{t('offers.29')}</p>
                <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] w-[205px] text-center">{t('offers.30')}</p>
                <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21] w-[205px] text-center">{t('offers.31')}</p>
            </div>
            <img src={n_d} className="hidden xl:block mx-auto mt-[20px]" alt="" />
            <div className="xl:flex items-start justify-center gap-[65px] mt-[20px] hidden">
                <p className="ibm-plex font-[500] text-[12px] xl:text-[14px]  text-[#000000B2] w-[205px] text-center"><Trans>{t('offers.32')}</Trans></p>
                <p className="ibm-plex font-[500] text-[12px] xl:text-[14px]  text-[#000000B2] w-[205px] text-center"><Trans>{t('offers.33')}</Trans></p>
                <p className="ibm-plex font-[500] text-[12px] xl:text-[14px]  text-[#000000B2] w-[205px] text-center"><Trans>{t('offers.34')}</Trans></p>
                <p className="ibm-plex font-[500] text-[12px] xl:text-[14px]  text-[#000000B2] w-[205px] text-center"><Trans>{t('offers.35')}</Trans></p>
            </div>
            <div className="xl:hidden flex mx-[40px] mt-[20px]">
                <img src={n_m} className="" alt="" />
                <div className="mt-[35px] ml-[30px] flex flex-col">
                  <div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21]">{t('offers.28')}</p>
                    <p className="ibm-plex font-[500] text-[12px] xl:text-[14px]  text-[#000000B2]"><Trans>{t('offers.32')}</Trans></p>
                  </div>
                  <div className="mt-[60px]">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21]">{t('offers.29')}</p>
                    <p className="ibm-plex font-[500] text-[12px] xl:text-[14px]  text-[#000000B2]"><Trans>{t('offers.33')}</Trans></p>
                  </div>
                  <div className="mt-[25px]">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21]">{t('offers.30')}</p>
                    <p className="ibm-plex font-[500] text-[12px] xl:text-[14px]  text-[#000000B2]"><Trans>{t('offers.34')}</Trans></p>
                  </div>
                  <div className="mt-[70px]">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#1E1C21]">{t('offers.31')}</p>
                    <p className="ibm-plex font-[500] text-[12px] xl:text-[14px]  text-[#000000B2]"><Trans>{t('offers.35')}</Trans></p>
                  </div>
                </div>
            </div>
            
        </div>
      </div>
      <div className="max-w-[1220px] mx-[20px] flex flex-col items-center xl:justify-center xl:mx-auto bg-[#1E1C21] relative xl:h-[550px]">
        <Fade><img src={s1} className="absolute left-0 top-0 hidden xl:block" alt="" /></Fade>
        <Fade><img src={s2} className="absolute right-0 top-0 hidden xl:block" alt="" /></Fade>
        <div className="mx-[20px] relative flex flex-col mt-[80px] xl:mt-0">
          <p className="text-white text-[24px] xl:text-[36px] zen-dots text-center">{t('offers.36')}</p>
          <p className="text-[#FFFFFFB2] text-[12px] xl:text-[14px] ibm-plex max-w-[573px] mt-[20px] text-center">{t('offers.37')}</p>
          <p className="text-[#FFFFFFB2] text-[12px] xl:text-[14px] ibm-plex max-w-[573px] mt-[20px] text-center">{t('offers.38')}</p>
          <a href={link} className="mx-auto mt-[50px]">
              <div className={`px-[70px] bg-[#FE7320] py-[16px] flex items-center justify-center rounded-[60px] hover:scale-[0.95] transition-all`}>
                  <p className={`uppercase ibm-plex text-[14px] text-[#FFFFFF] xl:text-[16px]`}>{t('offers.5')}</p>
              </div>
          </a>
        </div>
        <img src={smob} className="w-full xl:hidden mt-[-80px]" alt="" />
      </div>
    </div>
  );
}

export default Campaign;
